.badge {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  max-width: 100%;
  height: 22px;
  padding: 0 var(--space-2);
  border-radius: var(--radius-full);
  font-size: var(--text-xs);
  font-weight: var(--weight-medium);
  line-height: 1;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.badge svg {
  width: 12px;
  height: 12px;
}

.text {
  overflow: hidden;
  text-overflow: ellipsis;
}

.neutral {
  background: var(--color-surface-sunken);
  color: var(--color-text-muted);
}

.accent {
  background: var(--color-accent-soft);
  color: var(--color-accent-text);
}

.success {
  background: var(--color-success-soft);
  color: var(--color-success);
}

.warning {
  background: var(--color-warning-soft);
  color: var(--color-warning);
}

.danger {
  background: var(--color-danger-soft);
  color: var(--color-danger-text);
}
